import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
//imported
import { resendOtp, sendOtp, verifyOtp } from 'store/services/authService';
import * as Path from 'Routes/paths';
import Form from './Form';
import { getPhoneValue } from "helpers/common";
import VerifyPhoneOtpPopup from "components/Modals/VerifyPhoneOtpPopup";
import { useSelector } from "react-redux";
import { SUCCESS_MESSAGE } from "common/constantMessage";

const SignUp = ({ dispatch, submitting }) => {
  const navigate = useNavigate();
  const registrationDetails = useSelector((state) => state.Auth.registrationDetails);
  const [showPhoneVerifyPopup, setShowPhoneVerifyPopup] = useState(false);
  const [verifiedPhone, setVerifiedPhone] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone: {
      phone: "",
      country_code: "",
    },
    password: "",
    confirm_password: ""
  };

  const submitData_ = async (values, { setSubmitting }) => {
    try {
      if(verifiedPhone !== getPhoneValue(values?.phone) && values?.phone?.phone && values?.phone?.country_code) {
        const payload = {
          identifier: values.phone?.phone,
          country_code: values.phone?.country_code,
          identifier_type: "phone",
          action: "register"
        }

        await dispatch(sendOtp(payload, values));
        setShowPhoneVerifyPopup(true);
      } else {
        await proceedToEmailVerification(values);
      }
      setSubmitting(false);
    } catch (err) {
      console.log(err, "==============================");
      setSubmitting(false);
    }
  }

  const handleVerifyPhone = async (values, { setSubmitting }) => {
    try {
      setLoading(true);
      const payload = {
        identifier: registrationDetails.phone?.phone,
        country_code: registrationDetails.phone?.country_code,
        identifier_type: "phone",
        otp_code: values.otp
      }
      await verifyOtp(payload);
      setVerifiedPhone(getPhoneValue(registrationDetails?.phone));
      setShowPhoneVerifyPopup(false);
      await proceedToEmailVerification(registrationDetails);
    } catch(err) {
      console.log("Error verifying Otp", err);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  }

  const proceedToEmailVerification = async (values) => {
    try {
      const payload = {
        identifier: values.email,
        identifier_type: "email",
        action: "register"
      }
      await dispatch(sendOtp(payload, values));
      navigate(Path.verifyOTP);
    } catch(err) {
      console.error("Error requesting email OTP", err);
    }
  }

  const handleResendPhoneOtp = async (callback) => {
    try {
      const payload = {
        identifier: registrationDetails?.phone?.phone,
        country_code: registrationDetails?.phone?.country_code,
        identifier_type: "phone",
        action: "register"
      }

      let resposne = await resendOtp(payload);
      if(resposne?.success === true) {
        typeof callback === 'function' && callback();
        SUCCESS_MESSAGE("OTP sent successfully");
      }
    } catch(err) {
      console.log("Error resending Otp", err);
    }
  }

  return (
    <>
      {/* <AuthLayout> */}
      <VerifyPhoneOtpPopup
        showPopup={showPhoneVerifyPopup}
        handleClose={() => setShowPhoneVerifyPopup(false)}
        handleVerify={handleVerifyPhone}
        handleResendOtp={handleResendPhoneOtp}
        phone={registrationDetails?.phone}
      />
      <div className="FormInner py-5 bg-white px-sm-5 px-4">
        <div className="top mb-3">
          <label className="m-0 form-label">Welcome back</label>
          <h2 className="m-0 fw-bold">Practitioner Sign Up</h2>
        </div>
        <div className="FormBody">
          <Form
            initialValues={initialValues}
            updateData_={submitData_}
            verifiedPhone={verifiedPhone}
            isLoading={isLoading}
          />
        </div>
      </div>
      {/* </AuthLayout> */}
    </>
  );
};


const mapStateToProps = (state) => {
  return {
  }
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);